export const SUBNAV_OFFSET_PX = "90px";
export const UNKNOWN_SPEAKER = "UNKNOWN_SPEAKER";
export const SUPPRESSED_SPEAKER_NAMES = ["Multiple Speakers", UNKNOWN_SPEAKER];

export const EDITING_TOOLTIP = {
  nothingToEdit: "There's nothing to edit in this report",
  previewReport: "Upgrade to edit report",
  cannotEditSection:
    "You have viewer access, so you cannot edit this part of the report",
  nothingToEditInSection: "There is nothing to edit here",
  editingTranscript:
    "You're currently editing the transcript. To edit the notes, first save your changes to the transcript.",
  editingNotes:
    "You're currently editing the notes. To edit the transcript, first save your changes to the notes.",
};

export const PAGE_QUERY_PARAM_NAME = "page";
